/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Order_Form_Invoice_Buyer_TypeInputs */

const vi_order_form_invoice_buyer_type = /** @type {(inputs: Order_Form_Invoice_Buyer_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Người mua trên hóa đơn`)
};

/**

* @param {Order_Form_Invoice_Buyer_TypeInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const order_form_invoice_buyer_type = /** @type {((inputs?: Order_Form_Invoice_Buyer_TypeInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Order_Form_Invoice_Buyer_TypeInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_order_form_invoice_buyer_type(inputs)
});